import * as React from "react";
import Modal from 'react-bootstrap/Modal';

interface onSubmitFunction {
  (event : React.MouseEvent) : void;
}

export interface PopupConfirmProps {
  formFieldDefinition: any;
  onCancel : onSubmitFunction;
  onOK : onSubmitFunction;
}

export const PopupConfirm = (props: PopupConfirmProps) => <Modal className="form__popup" centered show={true} onHide={() => {}}>
        <Modal.Header className="form__popup-header">
          <Modal.Title>{props.formFieldDefinition.label}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="form__popup-content">
          <p className="form__popup-content-text">{props.formFieldDefinition.explanation !== undefined && props.formFieldDefinition.text !== "" ? props.formFieldDefinition.text : null}</p>
          <p className="form__popup-content-explanation">{props.formFieldDefinition.explanation !== undefined && props.formFieldDefinition.explanation !== "" ? props.formFieldDefinition.explanation : null}</p>
        </Modal.Body>
        <Modal.Footer className="form__popup-buttons">
          <a href="#" onClick={e => props.onCancel(e)} className="btn btn-outline-primary">Nee</a>
          <a href="#" onClick={e => props.onOK(e)} className="btn btn-form-submit">Ja</a>
        </Modal.Footer>
      </Modal>;

